<template>
  <div class="w-100 mb-5">
    <h2>Reserveren</h2>
    <p class="mt-5">Super! Bedankt daarvoor! We hebben nog wel wat gegevens van je nodig:</p>
    <div class="row">
      <div class="col-sm pt-3">
        <p>Dit is wat je wilde geven voor € {{basket.value}}:</p>
        <div class="card" ref="printMe">
          <img :src="basket.artikel.img" alt class="card-img-top">
          <div class="card-body">
            <h5 class="card-title">{{basket.artikel.naam}} - € {{basket.value}}</h5>
            <h5
              class="card-title"
              v-if="userInfo.voornaam"
            >van {{userInfo.voornaam}} {{userInfo.achternaam}}</h5>
            <div class="card-text">{{userInfo.tekstje}}</div>
          </div>
        </div>
      </div>
      <div class="col-sm pt-3">
        <form @submit.prevent>
          <div class="form-group">
            <label>Voornaam</label>
            <input
              type="text"
              class="form-control"
              v-model="userInfo.voornaam"
              required
              placeholder="Voornaam"
              autocomplete="given-name"
            >
          </div>
          <div class="form-group">
            <label>Achternaam</label>
            <input
              type="text"
              class="form-control"
              v-model="userInfo.achternaam"
              required
              placeholder="Acternaam"
              autocomplete="family-name"
            >
          </div>
          <div class="form-group mt-2">
            <label for>Adres</label>
            <input
              type="text"
              class="form-control"
              v-model="userInfo.adres"
              required="required"
              placeholder="Adres"
              autocomplete="address-line1"
            >
          </div>
          <div class="form-group mt-2">
            <label for="email">E-mail</label>
            <input
              type="email"
              required="required"
              class="form-control"
              v-model="userInfo.email"
              placeholder="Email"
              autocomplete="email"
            >
          </div>
          <div class="form-group mt-5">
            <label for="Tekstje">Als je wil, kan je een boodschap achterlaten ...</label>
            <textarea name id cols="30" rows="5" class="form-control" v-model="userInfo.tekstje"></textarea>
          </div>
          <button class="btn btn-outline-primary mt-4" @click="confirm">Bevestigen!</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState(["basket", "value", "currentUser"]),
    userInfo: {
      get() {
        return this.$store.state.userInfo;
      },
      set(val) {
        this.$store.commit("setUserinfo", val);
      }
    },
    donation() {
      return {
        ...this.userInfo,
        id: this.basket.artikel.id,
        artikel: this.basket.artikel.naam,
        value: this.basket.value,
        betaald: false,
        bedankt: false
      };
    }
  },
  methods: {
    ...mapActions(["makeReservation", "clearBasket"]),
    async confirm() {
      if (!this.userInfo.voornaam) {
        this.$alertify.alert("Vergeet je voornaam niet in te vullen!");
        return;
      } else if (!this.userInfo.achternaam) {
        this.$alertify.alert("Vergeet je achternaam niet in te vullen!");
        return;
      } else if (!this.userInfo.email) {
        this.$alertify.alert(
          "Zonder je e-mail adres kunnen we je niet bedanken!"
        );
        return;
      }

      this.$alertify.confirm("Alles nagekeken?", async () => {
        if (!this.currentUser) {
          try {
            // await this.$firebase.auth().signInAnonymously();
          } catch (err) {
            this.$alertify.error(
              "Oei, er ging iets mis. Contacteer kobededecker@gmail.com."
            );
            return;
          }
        }

        this.basket.artikel.prijs_donated =
          parseFloat(this.basket.artikel.prijs_donated) +
          parseFloat(this.basket.value);
        try {
          this.basket.doc.set(this.basket.artikel).then(
            res => {
              this.$firebase
                .firestore()
                .collection("donaties")
                .add(this.donation)
                .then(async res => {
                  await this.makeReservation({
                    ...this.basket,
                    confirmed: true
                  });
                  this.$router.push("/after");
                });
            },
            err => this.$alertify.error(err)
          );
        } catch (err) {
          this.$alertify.error(
            "Oeps, er is precies iets mis gegaan. Probeer je nog eens en stuur misschien een mailtje naar kobe."
          );
        }
      });
    }
  }
};
</script>
